export function CoreTimeDirective () {
  const regexObj = /^((0?\d|1[0-2]):?([0-5]\d)?\s?(AM|PM|A|P)?)$|^([01]?\d|2[0-3]):?([0-5]\d)?$/i;

  return {
    require: 'ngModel',
    link   ( scope, element, attrs, ctrl ) {
      ctrl.$parsers.push(( value ) => {
        if ( !value ) {
          ctrl.$setValidity('$valid', true);

          return '';
        }

        if ( value.match(regexObj) ) {
          const hour     = value.replace(regexObj, '$2');
          const meridian = value.replace(regexObj, '$4');

          let min     = value.replace(regexObj, '$3');
          let milHour = hour;

          // if its the first match (standard time)
          if ( value.replace(regexObj, '$5') === '' ) {
            if ( hour !== '12' && ( meridian.toLowerCase() === 'p' || meridian.toLowerCase() === 'pm' ) ) {
              milHour = (parseInt(hour) + 12).toString();
            } else if ( hour === '12' && ( meridian.toLowerCase() === 'a' || meridian.toLowerCase() === 'am' ) ) {
              milHour = '0';
            }

            ctrl.$setValidity('$valid', true);
            ctrl.$viewValue = value;
            ctrl.$render();
          }
          // or if its the second match (military time)
          else if ( value.replace(regexObj, '$1') === '' ) {
            milHour = value.replace(regexObj, '$5');
            min     = value.replace(regexObj, '$6');

            ctrl.$setValidity('$valid', true);
            ctrl.$viewValue = value;
            ctrl.$render();
          }

          const today = new Date();

          if ( min === '' ) {
            min = 0;
          }

          const fullDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(milHour), min);
          return fullDate.toISOString();
        }
        else {
          ctrl.$setValidity('$valid', false);
          return undefined;
        }
      });

      ctrl.$formatters.push(( value ) => {
        const fullDate = new Date(value);
        const milHour  = fullDate.getHours();
        const min      = ('0' + fullDate.getMinutes()).slice(-2);

        if ( !value ) {
          return '';
        }

        return milHour > 11
        ? `${ milHour - 12 || 12 }:${ min } PM`
        : `${ milHour || 12 }:${ min } AM`;
      });
    }
  };
}